export default __webpack_public_path__ + "static/media/card-m-product@2x.a916ee23.png";